export default "__VITE_ASSET__e6346a97__"